import {
  useEffect,
  useRef,
  useState
} from 'react'
import {
  useDispatch,
  useSelector
} from 'react-redux'
import { useSearchParams } from 'react-router-dom'
import {
  Image,
  Skeleton
} from '@chakra-ui/react'
import { ImagesPng } from 'assets/images'
import {
  handleOpenModal,
  markersSelectors,
  usersSelectors,
  setChosenFriends,
  setCloseChatModal,
  setHideChat,
  setSharingToFriends,
  setChatSectionPage,
  setUserSectionPage,
  setOpenPopupBlogs,
  setOpenPopupEvents,
  setNotificationSectionPage,
  setBlogRepostData
} from 'store'
import { fetchAvatarData } from 'store/chat/services'
import { chatCredentialsSelectors } from 'store/chat/selectors'
import {
  clearConnectedProfileChat,
  setForceCloseChatPanel,
  endMobileImagePicker,
  hideModalSpinner
} from 'store/chat/slice'
import { MODAL_SECTION } from 'utils/constants'
import {
  chatCounter,
  isAuth,
  showCoordParams
} from 'utils/helpers'
import { getMatrixClient } from './Matrix/clientStore'
import { Panels } from './Panels'
import {
  StyleMessengerBlock,
  StyleNumUnread
} from './styled'

export const Messenger = () => {
  const {
    blogLinkToBeCopied,
    notificationSectionPage,
    openChatModal,
    closeChatModal,
    sharingToFriends,
    hideChat,
    closeAllDrawers,
    chatSectionPage
  } = useSelector(usersSelectors)
  const {
    selectedEventData,
    selectedMarkerData
  } = useSelector(markersSelectors)
  const {
    numUnread,
    isMobileImagePickerState,
    isMobileImageTransferInprogress,
    forceCloseChatPanel,
    directRoomList
  } = useSelector(chatCredentialsSelectors)

  const btnRef = useRef()
  const pinBtnRef = useRef()
  const dispatch = useDispatch()

  const [showDropdown, setShowDropdown] = useState(false)
  const [attachmentBtnDisplay, setAttachmentBtnDisplay] = useState('none')
  const [isPinned, setIsPinned] = useState(false)
  const [sendBtnClicked, setSendBtnClicked] = useState(false)
  const [runHidePanel, setRunHidePanel] = useState(false)
  const [hidePanelAnimation, setHidePanelAnimation] = useState(false)
  const [runClosingAnimation, setRunClosingAnimation] = useState(false)
  const [searchParams, setSearchParams] = useSearchParams()
  const [shareText, setShareText] = useState('Article sent! Share with some friends who are not on Connector yet?')
  const [isLoaded, setIsLoaded] = useState(false)

  const friendId = document.querySelector('converse-chat-content')?.getAttribute('jid')?.split('-')[0] ?? 0

  const handleOpen = () => {
    if (document.querySelector('#NOTIFICATIONS-panel') === null) {
      dispatch(handleOpenModal({
        isOpen: chatSectionPage?.length,
        section: MODAL_SECTION.RightSection
      }))
    }
    setSearchParams({})

    dispatch(setChatSectionPage('chat-main'))
    dispatch(setHideChat(false))
    setRunClosingAnimation(!chatSectionPage?.length)

    localStorage.setItem('chatOpenedOn', new Date().toISOString())
    sessionStorage.setItem('isChatPanelOpen', 'true')
    sessionStorage.removeItem('chosenFriends')
    sessionStorage.removeItem('openProfileAfterAnimation')
    sessionStorage.removeItem('openEventAfterAnimation')

    // This is to ensure that chat panel display chat list when sharing blog
    setTimeout(() => {
      if (document.querySelector('#send-attachment-btn') && sharingToFriends) {
        document.querySelector('#chat-back-btn')?.click()
      }

      // Close chat panel if it is opened
      // to prevent user sending messages after unfriending
      if (forceCloseChatPanel) {
        dispatch(setForceCloseChatPanel(false))

        if (chatSectionPage.length > 1) {
          setTimeout(() => {
            // close chat panel after the drawer opening animation is complete
            const event = new CustomEvent('custom-chat-close_chat_panel')
            window.dispatchEvent(event)
          }, 350)
        }
      }
    }, 500)
  }

  const closeMessenger = (options) => {
    if (isMobileImagePickerState && !isMobileImageTransferInprogress) {
      dispatch(endMobileImagePicker())
      dispatch(hideModalSpinner())
    }

    dispatch(handleOpenModal({
      isOpen: notificationSectionPage?.length,
      section: MODAL_SECTION.RightSection
    }))

    // dispatch(setChatSectionPage('clear'))
    // dispatch(setSharingToFriends(false))
    // dispatch(clearConnectedProfileChat())
    // sessionStorage.setItem('isChatPanelOpen', 'false')
    // sessionStorage.setItem('isSharingBlog', 'false')
    // sessionStorage.removeItem('chosenFriends')
    // dispatch(setChosenFriends([]))
    // setSendBtnClicked(false)

    if (options?.pageName === 'chatview-panel') {
      dispatch(setChatSectionPage('clear'))
      dispatch(setChatSectionPage('chat-main'))
      sessionStorage.setItem('isChatPanelOpen', 'true')
      sessionStorage.setItem('isSharingBlog', 'false')
      sessionStorage.removeItem('roomId')
      dispatch(setSharingToFriends(false))
      dispatch(clearConnectedProfileChat())
      dispatch(setChosenFriends([]))
      setSendBtnClicked(false)
    } else {
      dispatch(setChatSectionPage('clear'))
      dispatch(setSharingToFriends(false))
      dispatch(clearConnectedProfileChat())
      sessionStorage.setItem('isChatPanelOpen', 'false')
      sessionStorage.setItem('isSharingBlog', 'false')
      sessionStorage.removeItem('chosenFriends')
      sessionStorage.removeItem('roomId')
      dispatch(setChosenFriends([]))
      setSendBtnClicked(false)

      // eslint-disable-next-line no-lonely-if
      if (options?.showParamIds) {
        if (selectedEventData?.id) {
          setTimeout(() => setSearchParams({ eventid: selectedEventData.id }), 800)
        } else if (selectedMarkerData?.id) {
          setTimeout(() => setSearchParams({ id: selectedMarkerData.id }), 800)
        }
      } else if (!options?.fromAnimatePressence) {
        setTimeout(() => showCoordParams(setSearchParams), 800)

        const ZoomCont = document.querySelector('.leaflet-control-zoom')
        const filterData = document.querySelector('.filter-data')
        const markerCountBox = document.querySelector('.marker-count')
        ZoomCont.style.opacity = 1
        ZoomCont.style.pointerEvents = 'auto'
        filterData.style.opacity = 1
        filterData.style.pointerEvents = 'auto'
        markerCountBox.style.opacity = 1
        markerCountBox.style.pointerEvents = 'auto'
      }
    }

    if (options?.showParamIds) {
      if (selectedEventData?.id) {
        setTimeout(() => setSearchParams({ eventid: selectedEventData.id }), 800)
      } else if (selectedMarkerData?.id) {
        setTimeout(() => setSearchParams({ id: selectedMarkerData.id }), 800)
      }
    } else if (!options?.fromAnimatePressence) {
      setTimeout(() => showCoordParams(setSearchParams), 800)

      const ZoomCont = document.querySelector('.leaflet-control-zoom')
      const filterData = document.querySelector('.filter-data')
      const markerCountBox = document.querySelector('.marker-count')
      ZoomCont.style.opacity = 1
      ZoomCont.style.pointerEvents = 'auto'
      filterData.style.opacity = 1
      filterData.style.pointerEvents = 'auto'
      markerCountBox.style.opacity = 1
      markerCountBox.style.pointerEvents = 'auto'
    }
  }

  useEffect(() => {
    const client = getMatrixClient()

    if (
      client
      && directRoomList?.length
    ) {
      directRoomList.forEach((room) => {
        if (!room?.avatarUrl) {
          const roomItem = client.getRoom(room?.roomId)

          const mxcUrl = roomItem?.getMxcAvatarUrl()
            ?? roomItem?.getAvatarFallbackMember()?.getMxcAvatarUrl()
          const httpUrl = client.mxcUrlToHttp(mxcUrl, 96, 96, 'crop', false, true, true)

          if (mxcUrl) {
            dispatch(fetchAvatarData({
              httpUrl,
              roomId: room?.roomId
            }))
          }
        }
      })
    }
  }, [directRoomList?.length])

  setTimeout(() => {
    const existing = document.querySelector('#send-attachment-btn')

    setAttachmentBtnDisplay(existing ? 'inline-flex' : 'none')
  }, 300)

  useEffect(() => {
    if (attachmentBtnDisplay === 'none') {
      setShowDropdown(false)
    }
  }, [attachmentBtnDisplay])

  useEffect(() => {
    if (showDropdown) {
      const pinnedFriends = JSON.parse(localStorage.getItem('pinnedFriends'))

      if (
        pinnedFriends.length
        && pinnedFriends.find((friend) => friend.friendId === parseInt(friendId, 10))
        && pinBtnRef.current
        && !isPinned
      ) {
        setIsPinned(true)
      }
    }
  }, [showDropdown])

  useEffect(() => {
    if (openChatModal && !selectedMarkerData) {
      handleOpen()
    }
  }, [openChatModal])

  useEffect(() => {
    if (closeChatModal) {
      dispatch(setCloseChatModal(false))
      closeMessenger()
    }
  }, [closeChatModal])

  useEffect(() => {
    setHidePanelAnimation(true)
    setRunHidePanel(hideChat)
    setTimeout(() => setHidePanelAnimation(false), 800)
  }, [hideChat])

  useEffect(() => {
    if (closeAllDrawers) {
      closeMessenger()
    }
  }, [closeAllDrawers])

  useEffect(() => {
    if (blogLinkToBeCopied.includes('/?eventid=')) {
      setShareText('Event sent! Share with some friends who are not on Connector yet?')
    } else {
      setShareText('Article sent! Share with some friends who are not on Connector yet?')
    }
  }, [blogLinkToBeCopied])

  useEffect(() => {
    // This is to ensure that chat panel display chat list when sharing blog
    if (sharingToFriends && document.querySelector('#send-attachment-btn')) {
      const bckBtn = document.querySelector('#chat-back-btn')

      if (bckBtn) {
        bckBtn.click()
      }
    }
  }, [sharingToFriends])

  useEffect(() => {
    if (chatSectionPage.length === 1) {
      handleOpen()
    }
  }, [chatSectionPage])

  return (
    <>
      <StyleMessengerBlock
        zIndex={isAuth() ? 1401 : 1392}
        onClick={() => {
          if (isMobileImagePickerState && !isMobileImageTransferInprogress) {
            dispatch(endMobileImagePicker())
            dispatch(hideModalSpinner())
          }

          dispatch(handleOpenModal({
            isOpen: notificationSectionPage?.length,
            section: MODAL_SECTION.RightSection
          }))

          dispatch(setChatSectionPage('clear'))
          dispatch(setSharingToFriends(false))
          dispatch(clearConnectedProfileChat())
          sessionStorage.setItem('isChatPanelOpen', 'false')
          sessionStorage.setItem('isSharingBlog', 'false')
          sessionStorage.removeItem('chosenFriends')
          dispatch(setChosenFriends([]))
          setSendBtnClicked(false)

          document.querySelector('#custom-popup-overlay')?.click()
          document.querySelector('#custom-popup-overlay-event')?.click()

          dispatch(setUserSectionPage('clear'))
          dispatch(setOpenPopupBlogs(false))
          dispatch(setOpenPopupEvents(false))
          dispatch(setNotificationSectionPage('clear'))
          dispatch(setBlogRepostData([]))
          dispatch(setChatSectionPage('chat-main'))
        }}
      >
        <StyleNumUnread numUnread={numUnread}>
          { chatCounter(numUnread) }
        </StyleNumUnread>

        <Skeleton
          isLoaded={isLoaded}
          fadeDuration={1}
          borderRadius="full"
          boxSize="32px"
        >
          <Image
            boxSize="32px"
            cursor="pointer"
            objectFit="cover"
            src={ImagesPng.LogoHeader}
            alt="Logo"
            borderRadius="full"
            ref={btnRef}
            onLoad={() => setTimeout(() => setIsLoaded(true), 1000)}
          />
        </Skeleton>
      </StyleMessengerBlock>

      <Panels
        closeMessenger={closeMessenger}
        hidePanelAnimation={hidePanelAnimation}
        runClosingAnimation={runClosingAnimation}
        runHidePanel={runHidePanel}
        shareText={shareText}
        sendBtnClicked={sendBtnClicked}
        setSendBtnClicked={setSendBtnClicked}
      />
    </>
  )
}
